var Font = /** @class */ (function () {
    function Font(param) {
        var _this = this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return;
        }
        var keys = 'family,size,color,bold,underscore,italic';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
    }
    Font.prototype.toJSON = function () {
        return {
            "family": this.family,
            "size": this.size,
            "color": this.color,
            "bold": this.bold,
            "underscore": this.underscore,
            "italic": this.italic
        };
    };
    Font.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Font;
}());
export { Font };
//# sourceMappingURL=font.js.map